import { useState, useEffect } from 'react'

import { RecurlyContainer } from 'features/checkout'
import { useUser } from 'hooks/use-user'
import { CHECKOUT_SUBMIT_TYPE } from 'features/checkout/components/form/consts'
import ModalDialog from 'components/ui/modal-dialog'
import { Mixpanel } from 'utils/mixpanel'

import {
  DeclinedUpdatePaymentModal,
  SuccessUpdatePaymentModal,
  UpdatePaymentForm,
} from './components'

interface UpdatePaymentMethodModalProps {
  onRequestClose: () => void
  isOpen: boolean
}

export const UpdatePaymentMethodModal = (
  props: UpdatePaymentMethodModalProps,
) => {
  const { onRequestClose, isOpen } = props
  const { subscription } = useUser()

  const [isSuccess, setIsSuccess] = useState(false)
  const [isDeclined, setIsDeclined] = useState(false)

  useEffect(() => {
    if (isOpen) {
      Mixpanel.trackUpdateBillingInformationModalView()
    }
  }, [isOpen])

  if (isSuccess) return <SuccessUpdatePaymentModal />

  return (
    <ModalDialog
      maxSize="tw-max-w-2xl"
      variant="left"
      isOpen={isOpen}
      onClose={onRequestClose}
      zIndex="tw-z-[100000]"
      content={
        <RecurlyContainer
          tier={subscription!.tier}
          interval={subscription!.planInterval}
          submitType={CHECKOUT_SUBMIT_TYPE.update}
          onUpdateSuccess={() => setIsSuccess(true)}
        >
          <DeclinedUpdatePaymentModal
            isDeclined={isDeclined}
            setIsDeclined={setIsDeclined}
          />
          <UpdatePaymentForm onRequestClose={onRequestClose} />
        </RecurlyContainer>
      }
    />
  )
}
